module.exports = __webpack_public_path__ + "static/media/9.55feef4d.jpg";